import { Loader2, Plus } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { IS_LOCKED } from '../../apiBase';
import type { PartItem } from './partsRun';
import type { useSaveAllToDb } from './partsToDb';

// THE PARTS DB'S "ADD ALL", under the "Found in database" label: every part of this manual the
// database does not have, saved in one press with the names and categories the table shows.
// Gone once there is nothing left to add; while it runs it counts the saves.
export function AddAllToDb({ todo, saving }: {
  todo: { at: number; item: PartItem; crop: string | null }[];
  saving: ReturnType<typeof useSaveAllToDb>;
}) {
  const { t } = useLanguage();
  const { run, progress, failed } = saving;
  if (!progress && !todo.length && !failed) return null;
  return (
    <div className="mt-2 flex flex-col items-center gap-1 normal-case tracking-normal">
      {(progress || todo.length > 0) && (
        <button
          type="button"
          disabled={!!progress || IS_LOCKED}
          onClick={() => void run(todo)}
          title={t('notice.parts.addAllTitle')}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-300 bg-white px-2.5 py-1.5 text-xs font-medium text-slate-600 transition-colors hover:border-blue-500 hover:text-blue-600 disabled:cursor-default disabled:opacity-60 disabled:hover:border-slate-300 disabled:hover:text-slate-600"
        >
          {progress ? (
            <>
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
              {progress.done}/{progress.of}
            </>
          ) : (
            <>
              <Plus className="h-3.5 w-3.5" />
              {t('notice.parts.addAllToDb').replace('{n}', String(todo.length))}
            </>
          )}
        </button>
      )}
      {failed > 0 && !progress && (
        <span className="text-[11px] font-medium text-rose-600">
          {t('notice.parts.addAllFailed').replace('{n}', String(failed))}
        </span>
      )}
    </div>
  );
}
